import React, { useEffect, useState } from "react";
import "../css/loyalty.css";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable"; // ✅ Import the plugin
import { useNavigate } from "react-router-dom";


const LoyaltyPointsPage = () => {
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();

// 🔍 Filtered customers
const filteredCustomers = customers.filter(cust =>
  cust.name.toLowerCase().includes(searchTerm.toLowerCase())
);

// 📤 CSV Export
const exportCSV = () => {
  const rowsWithPoints = filteredCustomers.filter((c) => c.points > 0);
  const csvContent = [
    ["Customer", "Phone", "Total Points"],
    ...rowsWithPoints.map((c) => [
      c.name,
      c.phone || c.contact || "-",
      Number(c.points || 0) // ⬅️ safe numeric value
    ])
    
  ]
    .map((row) => row.join(","))
    .join("\n");

  const blob = new Blob([csvContent], { type: "text/csv" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = "loyalty_points.csv";
  a.click();
};

const exportPDF = () => {
  const doc = new jsPDF();
  const rowsWithPoints = filteredCustomers.filter((c) => c.points > 0);
  const totalPoints = rowsWithPoints.reduce(
    (sum, c) => sum + Number(c.points || 0),
    0
  );
  

  const now = new Date().toLocaleString();

  // 🧾 Business Info (centered)
  doc.setFontSize(12);
  doc.text("RCS TOPUP AND BILLING ENTITY", 105, 10, null, null, "center");
  doc.text("22 BELLE PLAINE WAKENAAM", 105, 16, null, null, "center");
  doc.text("(592) 662 7987 // (592) 649 1514", 105, 22, null, null, "center");
  doc.line(20, 26, 190, 26); // horizontal line

  // 📄 Title and Date
  doc.setFontSize(14);
  doc.text("Loyalty Points Report", 105, 35, null, null, "center");
  doc.setFontSize(10);
  doc.text(`Generated: ${now}`, 105, 41, null, null, "center");

  // 🧮 Table
  autoTable(doc, {
    head: [["Customer", "Phone", "Total Points"]],
    body: rowsWithPoints.map((c) => [
      c.name,
      c.phone || c.contact || "-",
      c.points
    ]),
    startY: 48,
    didDrawPage: (data) => {
      // Add grand total after last row
      const finalY = data.cursor.y + 5;
      doc.setFont("helvetica", "bold");
      doc.text(
        `Grand Total Points: ${totalPoints}`,
        190,
        finalY,
        { align: "right" }
      );
    }
  });

  doc.save("loyalty_points.pdf");
};


  useEffect(() => {
    const fetchCustomers = async () => {
      try {
        const res = await fetch("https://pos-backend-58o9.onrender.com/api/customers");
        const customerList = await res.json();

        // Fetch points for each customer
        const customersWithPoints = await Promise.all(
          customerList.map(async (customer) => {
            const pointRes = await fetch(
              `https://pos-backend-58o9.onrender.com/api/loyalty/${customer.id}`
            );
            const pointData = await pointRes.json();
            return {
              ...customer,
              points: pointData.available_points || 0,
            };
          })
        );

        setCustomers(customersWithPoints);
        setLoading(false);
      } catch (err) {
        console.error("Failed to fetch loyalty points list:", err);
        setLoading(false);
      }
    };

    fetchCustomers();
  }, []);

  return (
    <div className="loyalty-container">
      <h2>Loyalty Points Overview 🏆</h2>

      <div className="loyalty-controls">
  <input
    type="text"
    placeholder="Search customer..."
    value={searchTerm}
    onChange={(e) => setSearchTerm(e.target.value)}
    className="loyalty-search"
  />
  <button onClick={exportCSV}>Export CSV</button>
  <button onClick={exportPDF}>Export PDF</button>
</div>


      {loading ? (
        <p>Loading...</p>
      ) : (
        <table className="loyalty-table">
          <thead>
            <tr>
              <th>Customer</th>
              <th>Phone</th>
              <th>Total Points</th>
            </tr>
          </thead>
          <tbody>
  {filteredCustomers.map((cust) => (
    <tr
      key={cust.id}
      onClick={() => navigate(`/loyalty/${cust.id}`)} // 👈 Navigate to detail page
      style={{ cursor: "pointer" }}
    >
      <td>{cust.name}</td>
      <td>{cust.phone || cust.contact || "-"}</td>
      <td>{cust.points}</td>
    </tr>
  ))}
</tbody>


        </table>
      )}
    </div>
  );
};

export default LoyaltyPointsPage;
